import { useMutation, useQueryClient } from '@tanstack/react-query'

import { updateItem } from '@flecto/api/saas'
import { type CoreItemPayload, type ParameterID } from '@flecto/types'

type MutationPayload = {
  itemId?: ParameterID
  item: CoreItemPayload
}

export function useMutationUpdateItem() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['MutationUpdateItem'],
    mutationFn: async ({ itemId, item }: MutationPayload) => {
      const response = await updateItem(itemId ?? '', item)
      queryClient.invalidateQueries(['QueryGetAllItems'])
      return response
    },
  })
}
